<template>
	<div>
        <div class="row" style="margin-top:-10px;">
            <div class="col-md-12">
                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.chart" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right">
                            <el-form-item label=" ">
                                <label v-if="lastUpdate != ''">{{ this.lastUpdate }}</label>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <PetaGmap v-if="showmap" :zoom="this.zoom" :centeringMap="centeringMap" :stationListMap="stationListMap" @pilihStationDariGmap="pilihStationDariGmap"/>
            </div>
            <div class="col-md-6 mt-1 text-left mb-0 pl-3">
                <div>
                    <img :src="imageKso" style="width:22px;">&nbsp;KSO&nbsp;
                    <img :src="imageTolNonTol" style="width:22px;">&nbsp;Tol & Non Tol
                    <img :src="imagePertashop" style="width:22px;">&nbsp;Pertashop
                </div>
            </div>
            
        </div>

        <div class="row">
            <div class="d-flex align-items-stretch col-md-4" style="">
                <div class="" style="width:100%;">
                    <!--<h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">SPBU KSO</h6>-->
                    <div class="title-pencapaian mb-3">SPBU KSO</div>
                    <div class="mb-2">
                        <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                        <img :src="require(`@/assets/img/spbu1.png`)" style="width:100%;border-radius: 6px;">
                    </div>
                    <div>
                        <h3 style="color:#FF7711;"><b>SPBU KSO</b></h3> 
                        <div v-html="reportdata.data.description_kso"></div> <!--                    
                        <p style="color:#2F5597;"><b>Adanya penambahan kerjasama KSO TAC Ytd Mei sebagai berikut : </b></p>
                        <ol style="color:#2F5597;">
                            <li><b>SPBU Nasution – Medan</b></li>
                            <li><b>SPBU Bandar Ratu – Bengkulu</b></li>
                            <li><b>SPBU Kota Malang – Bandung</b></li>
                            <li><b>SPBU Panglima Utar Kotawaringin Barat – Kalteng</b></li>
                            <li><b>SPBU Wonosari – Gorontalo</b></li>
                            <li><b>SPBU Bitung - Manado</b></li>
                        </ol>-->
                    </div>
                </div>
                <Loader v-if="loading.table"/>
            </div>

           
            <div class="d-flex align-items-stretch col-md-4" style="padding-left:0px;padding-right:0px;">
                <div class="" style="width:100%;">
                    <!--<h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">SPBU TOL & NON TOL</h6>  -->
                    <div class="title-pencapaian mb-3">SPBU TOL & NON TOL</div>               
                    <div class="mb-2">
                        <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                        <img :src="require(`@/assets/img/spbu2.png`)" style="width:100%;border-radius: 6px;">
                    </div>
                    <div>
                        <h3 style="color:#FF7711;"><b>SPBU TOL & NON TOL</b></h3>
                        <div v-html="reportdata.data.description_tol_non_tol"></div> <!--
                        <ol style="color:#2F5597;">
                            <li><b>Masih berprogress terkait dalam tahapan pembangunan untuk SPBU Universitas Padjajaran</b></li>
                            <li><b>Masih berprogress terkait dalam tahap negosiasi untuk SPBU Modular di KM 456 A Semarang – Jawa Tengah</b></li>
                        </ol>-->
                    </div>
                </div>
                <Loader v-if="loading.table"/>
            </div>

            <div class="d-flex align-items-stretch col-md-4" style="">
                <div class="" style="width:100%;">
                    <!--<h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">PERTASHOP</h6>-->
                    <div class="title-pencapaian mb-3">PERTASHOP</div>
                    <div class="mb-2">
                        <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                        <img :src="require(`@/assets/img/spbu3.png`)" style="width:100%;border-radius: 6px;">
                    </div>
                    <div>
                        <h3 style="color:#FF7711;"><b>PERTASHOP</b></h3>
                        <div v-html="reportdata.data.description_pertashop"></div> <!--
                        <ol style="color:#2F5597;">
                            <li><b>Belum adanya penambahan Pengalihan skema Pertashop COCO menjadi CODO sebanyak 380 unit.</b></li>
                            <li><b>Tahun 2022 – Mei 2023 telah terjual unit modular Pertashop DODO sebanyak  87 unit.</b></li>
                            <li><b>Total terjual selama 2020 – Mei 2023 sebanyak 2189 unit.</b></li>
                        </ol>-->
                    </div>
                </div>
                <Loader v-if="loading.table"/>
            </div>

        </div>
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import PetaGmap from '@/components/map/gmapPertumbuhanOutlet.vue'
import {Rainbow, FuelColor, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        PetaGmap,
        Loader,
		//ReportParamSelect,
        //'editor': Editor,
	},

	data() {
		return {
            showmap: true,
            stationListMap:[],
			centeringMap:{},
			zoom:5, 
            imageKso: Config().webURL+'/ic_marker_old_blue.png',
            imageTolNonTol: Config().webURL+'/ic_marker_sky_blue.png',
            imagePertashop: Config().webURL+'/ic_marker_red.png',

            loading: {
                chart: false,
                table: false,
            },

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            reportdata: {
                data: {
                    outlet: [],
                    description_kso: "",
                    description_tol_non_tol: "",
                    description_pertashop: "",
                    description_lpg: "",
                    description_bright: "",
                    description_spklu: "",
                }
            },
        }
    },

    watch: {
        reportdata(){
            //this.refreshChart();

			this.stationListMap = this.reportdata.data.outlet
				.filter(e=> e.Latitude!==null && e.Longitude!==null)
				.map(item=>Object.assign(item,
					{id:item.StationId,name:item.StationName,lat:Number(item.Latitude.replace(',','.')),lng:Number(item.Longitude.replace(',','.'))}))
		
			console.log('this.stationListMap FUEL: ' + JSON.stringify(this.stationListMap))
		},
    },

    mounted()
    {
        //this.$emit('childrenRoute')
        this.setDefaultPeriod()
        this.getOutlets()
    },
    methods:{
        pilihStationDariGmap(stationId,PlantNo) {
            //this.$router.push({ path: '/plant', query: { plant: PlantNo ,station: stationId } })
            //location.reload()
        },

        getOutlets() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/outlet-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&productType=FUEL'

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
                this.lastUpdate = response.data.last_update
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        applyFilter() {
            this.getOutlets()
        },

        setDefaultPeriod() {
            // Mengecek apakah kunci 'username' sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },

    }
}
</script>

<style>
.title-pencapaian {
    background: #409EFF;
    color:white;
    text-align:center;
    border-radius:2px;
    padding-top:5px;
    padding-bottom:5px;
    font-weight:bold;
    font-family: Arial, Helvetica, sans-serif;
}
</style>